// extracted by mini-css-extract-plugin
var _1 = "ClientBookingsTableRow_discountRow__H1U2t";
export { _1 as "discountRow" }
